import {FormControlLabel, FormGroup, Switch} from '@mui/material';
import {useField, useFormikContext} from 'formik';
import {notEmpty} from 'main/utility/CommonUtil';
import PropTypes from 'prop-types';

const AppOptFldSwitch = (props) => {
  const {options, optionalignment, labelid, multivalue: isMulti} = props;
  const [field] = useField(props);
  const {setFieldValue} = useFormikContext();

  const hasOptions = notEmpty(options);
  const optionInRow = optionalignment !== 'vertical';

  const handleChange = (optionValue) => (event) => {
    const checked = event.target.checked;

    if (isMulti) {
      const current = Array.isArray(field.value) ? field.value : [];
      const nextValue = checked
        ? current.includes(optionValue)
          ? current
          : [...current, optionValue]
        : current.filter((v) => v !== optionValue);

      setFieldValue(field.name, nextValue);
    } else {
      setFieldValue(field.name, checked ? optionValue : '');
    }
  };

  const isChecked = (optionValue) => {
    if (isMulti) {
      return Array.isArray(field.value) && field.value.includes(optionValue);
    }
    return field.value === optionValue;
  };

  return (
    <FormGroup row={optionInRow} aria-labelledby={labelid}>
      {hasOptions &&
        options.map((option) => (
          <FormControlLabel
            key={`${field.name}:${option.value}`}
            name={field.name}
            label={option.label}
            control={
              <Switch
                checked={isChecked(option.value)}
                onChange={handleChange(option.value)}
              />
            }
          />
        ))}
    </FormGroup>
  );
};

AppOptFldSwitch.propTypes = {
  labelid: PropTypes.string,
  required: PropTypes.bool,
  multivalue: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ).isRequired,
  optionalignment: PropTypes.oneOf(['vertical', 'horizontal']),
};

export default AppOptFldSwitch;
